import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Download } from '../../model';

@Injectable({
  providedIn: 'root',
})
export class DownloadStore {
  private selectedDownload = new BehaviorSubject<Download | undefined>(
    undefined,
  );

  private focusDetailLinkRequested = false;

  public selectedDownload$: Observable<Download | undefined> =
    this.selectedDownload.asObservable();

  setSelectedDownload(download: Download): void {
    this.focusDetailLinkRequested = false;
    this.selectedDownload.next(download);
  }

  resetSelectedDownload(): void {
    this.selectedDownload.next(undefined);
  }

  requestDetailLinkFocus(): void {
    this.focusDetailLinkRequested = true;
  }

  consumeDetailLinkFocusRequest(): boolean {
    const requested = this.focusDetailLinkRequested;
    this.focusDetailLinkRequested = false;
    return requested;
  }
}
